<template>
  <div class="register-container">
    <!-- Mask Decoration -->
    <div class="mask-decoration"></div>

    <!-- Main Layout -->
    <div class="container-fluid min-vh-100 d-flex p-0">
      <div class="row w-100 m-0 g-0">
        <!-- Left Side: Image -->
        <div class="col-lg-5 d-none d-lg-block p-4 d-flex align-items-center">
          <div class="register-image-wrapper h-100 w-100">
            <img
              src="../../../public/img/register_image.jpg"
              alt="Register Image"
              class="register-image"
            />
          </div>
        </div>

        <!-- Right Side: Form -->
        <div class="col-12 col-lg-7 d-flex flex-column justify-content-center align-items-center position-relative py-3 overflow-y-auto">
          <div class="register-content-wrapper w-100">
            <!-- Logos Left Aligned -->
            <div class="d-flex justify-content-start align-items-center mb-2 gap-3">
              <div class="logo-box">
                <img
                  src="../../../public/img/ccd_escudo.png"
                  class="escudo-logo escudo-ccd"
                  alt="CCD Logo"
                />
              </div>
              <div class="logo-divider"></div>
              <div class="logo-box">
                <img
                  src="../../../public/img/fvf_escudo.png"
                  class="escudo-logo escudo-fvf"
                  alt="FVF Logo"
                />
              </div>
            </div>

            <div class="text-start mb-3">
              <h1 class="font-weight-bolder text-dark mb-1">REGISTRO</h1>
              <p class="text-dark mb-0 subtitle-text">
                Completa los campos para crear tu cuenta en el panel del Centro de Capacitación y Desarrollo de la FVF
              </p>
            </div>

            <div class="form-container-register mx-auto">
              <form role="form" @submit.prevent="saveUser">
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Nombre</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Ingresa tu nombre"
                        v-model="form_save.first_name"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Apellido</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Ingresa tu apellido"
                        v-model="form_save.last_name"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Correo</label>
                      <input
                        type="text"
                        inputmode="email"
                        class="form-control"
                        placeholder="Ingresa tu correo"
                        v-model.trim="form_save.email"
                      />
                      <small v-if="form_save.email" class="text-danger d-block mt-1" style="font-size: 0.75rem; line-height: 1.2;">
                        Si utilizas el mismo correo de RNE, te recomendamos acceder con tu cuenta de RNE desde la otra opción.
                        <a href="registro-rne" class="text-danger font-weight-bold text-decoration-underline">Comienza por aquí</a>
                      </small>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Teléfono</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Ingresa tu teléfono"
                        v-model="form_save.phone"
                        name="phone"
                        autocomplete="new-password"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Cédula</label>
<input
  type="number"
  class="form-control"
  placeholder="Ingresa tu cédula"
  v-model="form_save.dni"
  name="dni"
  autocomplete="new-password"
/>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">País</label>
                      <multiselect
                        v-model="form_save.id_country"
                        label="name"
                        :options="CountryTmp"
                        selectLabel="Click/enter para elegir"
                        selectedLabel="Seleccionado"
                        deselectLabel="Click/Enter para remover"
                        placeholder="Selecciona tu país"
                        @select="onCountryChange"
                      >
                      </multiselect>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Estado</label>
                      <multiselect
                        v-model="form_save.id_state"
                        label="name"
                        :options="StateTmp"
                        selectLabel="Click/enter para elegir"
                        selectedLabel="Seleccionado"
                        deselectLabel="Click/Enter para remover"
                        placeholder="Selecciona tu estado"
                        :disabled="!form_save.id_country"
                        @select="onStateChange"
                      >
                      </multiselect>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Ciudad</label>
                      <multiselect
                        v-model="form_save.id_city"
                        label="name"
                        :options="CityTmp"
                        selectLabel="Click/enter para elegir"
                        selectedLabel="Seleccionado"
                        deselectLabel="Click/Enter para remover"
                        placeholder="Selecciona tu ciudad"
                        :disabled="!form_save.id_state"
                      >
                      </multiselect>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Contraseña</label>
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Ingresa tu contraseña"
                        v-model="form_save.password"
                        name="password"
                        autocomplete="new-password"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-2">
                      <label class="form-label">Confirmar contraseña</label>
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Confirma tu contraseña"
                        v-model="form_save.password2"
                        name="password2"
                        autocomplete="new-password"
                      />
                    </div>
                  </div>
                </div>

                <div class="text-center mt-3">
                  <p class="text-dark mb-1 small">
                    ¿Ya tienes cuenta? 
                    <a href="login" style="color: #BC9A52" class="font-weight-bold text-decoration-underline ml-1">Inicia sesión acá</a>
                  </p>
                  <p class="text-dark mb-0 small">
                    ¿Ya estás registrado en RNE? 
                    <a href="registro-rne" style="color: #BC9A52" class="font-weight-bold text-decoration-underline ml-1">Comienza por aquí</a>
                  </p>
                </div>

                <div class="text-end mt-4">
                  <button
                    type="submit"
                    class="btn golden-btn px-5"
                    style="background: #541A32 !important; border-radius: 30px; color: #fff !important;"
                    :disabled="isLoading"
                  >
                    <span v-if="!isLoading">Crear cuenta</span>
                    <span v-else>Registrando...</span>
                  </button>
                </div>
              </form>
            </div>
            
            <!-- Footer Text -->
            <div class="text-center mt-4">
              <p class="footer-text text-sm mb-0">
                &copy; {{ new Date().getFullYear() }} FVF / CCD By <a href="https://ticz.io/" target="_blank" rel="noopener noreferrer" class="ticz-link">TICZ</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import LayoutFooter from "./Layouts/Footer";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import EmailValidator from "email-validator";

// Add the missing CSS styles for the Multiselect component
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "register",
  components: {
    Multiselect,
    LayoutFooter,
  },
  data() {
    return {
      isLoading: false,
      form_save: {
        dni: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password2: "",
        phone: "",
        id_country: "",
        id_state: "",
        id_city: "",
      },

      CountryTmp: [],
      StateTmp: [],
      CityTmp: [],
    };
  },
  mounted() {
    this.loadCountry();
  },
  methods: {
    ...mapActions(["recoverData", "getRegisterData"]),

    saveUser() {
      // Sanitize email
      if (this.form_save.email) {
        this.form_save.email = this.form_save.email.trim().toLowerCase();
      }

      // Validate email
      if (!this.form_save.email || !EmailValidator.validate(this.form_save.email)) {
        Swal.fire({
          title: "Correo inválido",
          text: "Debes ingresar un correo electrónico válido para registrarte.",
          icon: "warning",
        });
        return;
      }

      // Validate required fields
      if (
        !this.form_save.first_name ||
        !this.form_save.last_name ||
        !this.form_save.dni ||
        !this.form_save.phone ||
        !this.form_save.id_country ||
        !this.form_save.id_state ||
        !this.form_save.id_city ||
        !this.form_save.password ||
        !this.form_save.password2
      ) {
        Swal.fire({
          title: "Completa los datos",
          text: "Debes completar todos los datos para registrarte",
          icon: "warning",
        });
        return;
      }

      // Validate password length
      if (this.form_save.password.length < 8) {
        Swal.fire({
          title: "Contraseña inválida",
          text: "La contraseña debe tener al menos 8 caracteres",
          icon: "warning",
        });
        return;
      }

      // Validate passwords match
      if (this.form_save.password !== this.form_save.password2) {
        Swal.fire({
          title: "Contraseñas diferentes",
          text: "Las contraseñas no coinciden",
          icon: "warning",
        });
        return;
      }

      // Confirm registration
      Swal.fire({
        title: "Registro de usuario",
        html: `¿Estás seguro de realizar el registro?<br><br>
               <span style="font-size: 0.85rem; color: #dc3545; display: block;">
                 Recuerda que si ya posees cuenta en el Registro Nacional de Entrenadores, te recomendamos registrarte usando el mismo correo desde esta opción, 
                 <a href="registro-rne" style="color: #BC9A52; font-weight: bold; text-decoration: underline;">haz clic aquí</a>.
               </span>`,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#B49B57",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, registrar",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;

          let form = {
            url: "auth/register_ccd",
            data: {
              first_name: this.form_save.first_name,
              last_name: this.form_save.last_name,
              password: this.form_save.password,
              password_confirmation: this.form_save.password2,
              email: this.form_save.email,
              phone: this.form_save.phone,
              dni: this.form_save.dni,
              id_country: this.form_save.id_country.id,
              id_state: this.form_save.id_state.id,
              id_city: this.form_save.id_city.id,
            },
          };

          this.recoverData(form)
            .then((response) => {
              this.isLoading = false;
              if (response.code === 200 || response.code === 201) {
                Swal.fire({
                  title: "¡Registro completado!",
                  text: "Usuario registrado correctamente. Gracias por registrarte en CCD",
                  icon: "success",
                  confirmButtonColor: "#B49B57",
                }).then(() => {
                  this.$router.push("/login");
                });
              } else if (response.code === 409) {
                Swal.fire({
                  title: "Ya existe un usuario con estos datos",
                  icon: "warning",
                });
              } else if (response.code === 408) {
                Swal.fire({
                  title: "Ya existe un usuario con este correo",
                  icon: "warning",
                });
              } else if (response.code === 403) {
                Swal.fire({
                  title: "Ya existe otro usuario con este teléfono",
                  icon: "warning",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
              Swal.fire({
                title: "Error",
                text: "Ocurrió un error, intente más tarde",
                icon: "error",
              });
            });
        }
      });
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite:1
        },
      };

      this.getRegisterData(form)
        .then((response) => {
          if (response.code === 200) {
            this.CountryTmp = response.data;
            // Preset Venezuela by name (agnostic of ID)
            const venezuela = this.CountryTmp.find((c) => c.name.toLowerCase() === "venezuela");
            if (venezuela) {
              this.form_save.id_country = venezuela;
              this.loadState();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onCountryChange(val) {
      this.form_save.id_country = val;
      this.loadState();
    },

    onStateChange(val) {
      this.form_save.id_state = val;
      this.loadCity();
    },

    loadState() {
      // Reset state and city when country changes
      this.form_save.id_state = "";
      this.form_save.id_city = "";
      this.StateTmp = [];
      this.CityTmp = [];

      if (!this.form_save.id_country) return;

      let form = {
        url: "master/state/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite:1,
          id_country: this.form_save.id_country.id,
        },
      };

      this.getRegisterData(form)
        .then((response) => {
          if (response.code === 200) {
            this.StateTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCity() {
      // Reset city when state changes
      this.form_save.id_city = "";
      this.CityTmp = [];

      if (!this.form_save.id_state) return;

      let form = {
        url: "master/city/all",
        params: {
          order_value: "asc",
          order_by: "name",
          active: 1,
          lite:1,
          id_state: this.form_save.id_state.id,
        },
      };

      this.getRegisterData(form)
        .then((response) => {
          if (response.code === 200) {
            this.CityTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
};
</script>
<style scoped>
/* Register container */
.register-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background-color: white;
  z-index: 1;
}

/* Mask Decoration */
.mask-decoration {
  position: absolute;
  top: 0;
  right: -370px;
  width: 70%;
  height: 100%;
  background-image: url("../../../public/img/ccd_mask.png");
  background-position: center right;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 99999;
  pointer-events: none;
  filter: brightness(0.5) opacity(0.3);
}

/* Left Side Image */
.register-image-wrapper {
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  max-height: 92vh;
  width: 100%;
  position: relative;
  z-index: 10;
}

.register-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Content Wrapper */
.register-content-wrapper {
  max-width: 900px;
  width: 90%;
  z-index: 10;
  position: relative;
}

/* Logos */
.logo-box {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.escudo-logo {
  object-fit: contain;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.1));
}

.escudo-ccd {
  height: 69px;
  width: auto;
}

.escudo-fvf {
  height: 70px;
  width: auto;
}

.logo-divider {
  width: 2px;
  height: 70px;
  background-color: rgba(0, 0, 0, 0.2);
}

/* Form Container */
.form-container-register {
  width: 100%;
  max-width: 800px;
}

/* Form controls */
.form-control {
  background: white !important;
  border-radius: 30px !important;
  border: 1px solid #ddd;
  padding: 8px 15px;
  height: 40px;
  color: #333 !important;
  font-size: 0.85rem;
}

.form-control:focus {
  background: white !important;
  border-color: #b49b57;
  box-shadow: 0 0 0 3px rgba(180, 155, 87, 0.15);
  color: #333;
}

.form-control::placeholder {
  color: #999;
}

label {
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 4px;
  color: #333;
}

/* Golden button */
.golden-btn {
  background: #b49b57;
  color: white;
  border-radius: 30px !important;
  padding: 10px 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(180, 155, 87, 0.3) !important;
  transition: all 0.3s ease;
  height: 45px;
  font-size: 1rem;
  border: none;
}

.golden-btn:hover {
  background: #cbb16a;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(180, 155, 87, 0.4) !important;
}

/* Footer text */
.footer-text {
  color: rgba(156, 156, 156, 1) !important;
}

.subtitle-text {
  font-size: 0.95rem;
}

/* Responsive Design */
@media (max-width: 991px) {
  .register-content-wrapper {
    max-width: 700px;
    padding: 15px;
  }
  
  .mask-decoration {
    width: 100%;
    opacity: 0.05;
    right: -200px;
  }
}

@media (max-width: 768px) {
  .logo-box {
    width: 50px;
    height: 50px;
  }
  
  .escudo-ccd {
    height: 40px;
  }
  
  .escudo-fvf {
    height: 55px;
  }
  
  .logo-divider {
    height: 55px;
  }
  
  .register-content-wrapper {
    width: 95%;
    padding: 10px;
  }
  
  .form-control {
    height: 46px;
    font-size: 1.1rem;
    padding: 8px 15px;
  }
  
  .golden-btn {
    height: 48px;
    font-size: 1.2rem;
  }
  
  h1 {
    font-size: 1.7rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 1.15rem !important;
  }
  
  label {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }
  
  .form-container-register {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .logo-box {
    width: 45px;
    height: 45px;
  }
  
  .escudo-ccd {
    height: 35px;
  }
  
  .escudo-fvf {
    height: 48px;
  }
  
  .logo-divider {
    height: 48px;
  }
  
  h1 {
    font-size: 1.6rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 1.1rem !important;
  }
  
  .form-control {
    height: 44px;
    font-size: 1.05rem;
    padding: 8px 12px;
  }
  
  .golden-btn {
    height: 46px;
    font-size: 1.15rem;
    padding: 8px 15px;
  }
  
  label {
    font-size: 1.05rem;
    margin-bottom: 4px;
  }
  
  .register-content-wrapper {
    padding: 8px;
  }
}

/* Altura específica para móviles */
@media (max-height: 700px) {
  .logo-box {
    width: 40px;
    height: 40px;
  }
  
  .escudo-ccd {
    height: 39px;
  }
  
  .escudo-fvf {
    height: 42px;
  }
  
  .logo-divider {
    height: 42px;
  }
  
  h1 {
    font-size: 1.35rem !important;
    margin-bottom: 0.25rem !important;
  }
  
  .text-center p, .subtitle-text {
    font-size: 0.95rem !important;
  }
  
  .form-control {
    height: 40px;
    font-size: 0.95rem;
  }
  
  .golden-btn {
    height: 42px;
    font-size: 1rem;
  }
  
  label {
    font-size: 0.95rem;
    margin-bottom: 2px;
  }
}
</style>
<style>
/* Global styles for multiselect and other components */
body {
  font-family: "Jost" !important;
}

.multiselect__tags {
  border-radius: 30px !important;
  border: 1px solid #ddd !important;
  min-height: 40px !important;
  padding: 6px 40px 0 8px !important;
}

.multiselect__content-wrapper {
  border-radius: 15px !important;
  position: absolute;
  z-index: 1000;
}

.multiselect__option--highlight {
  background: #b49b57 !important;
  background-color: #b49b57 !important;
}

.multiselect__option--highlight:after {
  background: #b49b57 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: rgb(53, 16, 32) !important;
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: rgb(53, 16, 32) !important;
}

/* SweetAlert styles */
.swal2-container.swal2-center > .swal2-popup {
  z-index: 10000 !important;
}

.swal2-container {
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm {
  background-color: #b49b57 !important;
  color: white !important;
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-cancel {
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm:focus {
  box-shadow: 0 0 0 3px rgba(180, 155, 87, 0.3) !important;
}

/* Button hover effects */
.btn:hover:not(.btn-icon-only) {
  transform: scale(1.02) !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Responsive multiselect */
@media (max-width: 768px) {
  .multiselect__tags {
    min-height: 38px !important;
    padding: 5px 40px 0 8px !important;
    font-size: 0.8rem !important;
  }
  
  .multiselect__input {
    font-size: 0.8rem !important;
  }
  
  .multiselect__single {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 576px) {
  .multiselect__tags {
    min-height: 36px !important;
    padding: 4px 40px 0 6px !important;
    font-size: 0.75rem !important;
  }
  
  .multiselect__input {
    font-size: 0.75rem !important;
  }
  
  .multiselect__single {
    font-size: 0.75rem !important;
  }
}

@media (max-height: 700px) {
  .multiselect__tags {
    min-height: 34px !important;
    padding: 3px 40px 0 6px !important;
    font-size: 0.7rem !important;
  }
  
  .multiselect__input {
    font-size: 0.7rem !important;
  }
  
  .multiselect__single {
    font-size: 0.7rem !important;
  }
}

.ticz-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease-out;
}

.ticz-link:hover {
  background-image: linear-gradient(90deg, #b49b57, #f5e3a1);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: -100% 50%;
  animation: ticzHoverPaint 0.7s forwards;
}

@keyframes ticzHoverPaint {
  0% {
    background-position: -100% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>
